import { Component } from '@angular/core';
import { CheckoutAccountStatusComponentDef } from '@df/checkout/checkout-account-status.component.def';
import { CheckoutFormComponent } from '../checkout-form.component';

@Component({
    selector: 'checkout-account-status',
    templateUrl: './checkout-account-status.component.html',
    standalone: true
})
export class CheckoutAccountStatusComponent extends CheckoutAccountStatusComponentDef {
    constructor(checkoutFormComponent: CheckoutFormComponent) {
        super(checkoutFormComponent);
    }
}
